// import React, { useState, useEffect, useCallback } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { MdKeyboardArrowLeft } from 'react-icons/md';
// import PropTypes from 'prop-types';

// import history from '../../../services/history';

// // import { Form } from '../../Form';
// // import Input from '../../Form/Input';
// import InputDefault from '../../InputDefault';

// import { Item } from './styles';

// function ItemMenuFabricante({ visible, color, title, active, backTo, items }) {
//   const { app, action } = useSelector((state) => state.auth || {});

//   // const formRef = useRef(null);

//   const [originalData, setOriginalData] = useState([]);
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     setOriginalData(items);
//     setData(items);
//   }, [items]);

//   const handleSearch = useCallback(
//     (e) => {
//       const { value = '' } = e.target || {};
//       const filtered = originalData.filter((d) =>
//         String(d.name).toUpperCase().includes(value.toUpperCase())
//       );
//       setData(filtered);
//     },
//     [originalData]
//   );

//   return (
//     <Item color={color} visible={visible}>
//       <Item.Title>
//         <div>
//           {(!app || action === 1) && backTo && (
//             <button type="button" onClick={() => history.push(backTo)}>
//               <MdKeyboardArrowLeft size={20} />
//             </button>
//           )}
//           <h2>{title}</h2>
//         </div>

//         {/* <Form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
//           <Input
//             id="search"
//             name="search"
//             placeholder="Buscar"
//             onChange={(e) => handleSearch(e)}
//             disabled={!active}
//           />
//         </Form> */}

//         <InputDefault
//           id="search"
//           name="search"
//           placeholder="Buscar"
//           onChange={(e) => handleSearch(e)}
//           disabled={!active}
//         />
//       </Item.Title>
//       <Item.Wrapper>
//         {data.map((item) => (
//           <li key={item.id}>
//             <Link
//               className={active ? '' : 'disabled-link'}
//               to={(path) => ({ ...path, search: item.linkTo })}
//             >
//               {item.name}
//             </Link>
//           </li>
//         ))}
//       </Item.Wrapper>
//     </Item>
//   );
// }

// ItemMenuFabricante.propTypes = {
//   visible: PropTypes.bool.isRequired,
//   color: PropTypes.string,
//   title: PropTypes.string.isRequired,
//   active: PropTypes.bool.isRequired,
//   backTo: PropTypes.string,
//   items: PropTypes.arrayOf(Object).isRequired,
// };

// ItemMenuFabricante.defaultProps = {
//   color: '#eef1f8',
//   backTo: '',
// };

// export { ItemMenuFabricante };

import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MdKeyboardArrowLeft, MdSearch } from 'react-icons/md';
import PropTypes from 'prop-types';
import history from '../../../services/history';
import InputDefault from '../../InputDefault';

import { Item, SearchWrapper } from './styles';

function ItemMenuFabricante({ visible, color, title, active, backTo, items }) {
  const { app, action } = useSelector((state) => state.auth || {});
  const location = useLocation();
  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    setOriginalData(items);
    setData(items);
  }, [items]);

  const handleSearch = useCallback(
    (e) => {
      const { value = '' } = e.target || {};
      setSearch(value);
      const filtered = originalData.filter((d) =>
        d.name.toLowerCase().includes(value.toLowerCase())
      );
      setData(filtered);
    },
    [originalData]
  );

  const currentSearch = new URLSearchParams(location.search).get('search');

  return (
    <Item color={color} visible={visible}>
      <Item.Title>
        <div className="header">
          {(!app || action === 1) && backTo && (
            <button
              type="button"
              onClick={() => history.push(backTo)}
              aria-label="Voltar"
            >
              <MdKeyboardArrowLeft size={24} />
            </button>
          )}
          <h2>{title}</h2>
        </div>

        <SearchWrapper>
          <MdSearch size={20} />
          <InputDefault
            id="search"
            name="search"
            placeholder="Buscar..."
            onChange={handleSearch}
            value={search}
            disabled={!active}
          />
        </SearchWrapper>
      </Item.Title>

      <Item.Wrapper>
        {data.map((item) => {
          const isSelected = currentSearch === item.linkTo;
          return (
            <li key={item.id}>
              <Link
                className={`
                  ${!active ? 'disabled-link' : ''}
                  ${isSelected ? 'selected' : ''}
                `}
                to={(path) => ({ ...path, search: item.linkTo })}
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </Item.Wrapper>
    </Item>
  );
}

ItemMenuFabricante.propTypes = {
  visible: PropTypes.bool.isRequired,
  color: PropTypes.string,
  title: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  backTo: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      linkTo: PropTypes.string.isRequired,
    })
  ).isRequired,
};

ItemMenuFabricante.defaultProps = {
  color: '#eef1f8',
  backTo: '',
};

export { ItemMenuFabricante };
